module.exports = __webpack_public_path__ + "img/diente_outline.324973cd.svg";